import { Injectable } from '@angular/core';
import { IVirtualRepeaterSearchable, IVirtualRepeaterSearchService } from '../../src/typings/services';

@Injectable({
    providedIn: 'root'
})
export class VirtualRepeaterSearchService implements IVirtualRepeaterSearchService {
    public static $name = 'virtualRepeaterSearchService';

    public performSearch(context: IVirtualRepeaterSearchable, divId: string, searchTerm: string) {
        context.searchTerm = searchTerm;
        context.dataTables[divId].repeatableItems = context.dataTables[divId].search(searchTerm);
    }
}
